module.exports = __webpack_public_path__ + "static/media/DMresume.24161646.pdf";